import PropTypes from 'prop-types';
import { MapGeometryShape } from '../../map/models/MapGeometry';

const PipelineCenterline = {
  geometry: MapGeometryShape,
  visible: PropTypes.bool,
};

export const PipelineCenterlineShape = PropTypes.shape(PipelineCenterline);
export const PipelineCenterlineExact = PropTypes.exact(PipelineCenterline);
